import { createFeature, createReducer, createSelector, on } from "@ngrx/store";
import { SubscriptionPlan } from "../models/company-entitlement.models";
import { SubscriptionsActions } from "./subscriptions.actions";

export interface SubscriptionsState {
    plans: SubscriptionPlan[];
    selectedPriceId: string | null;
    loading: boolean;
    submitting: boolean;
    completed: boolean;
    error: string | null;
}

const initialState: SubscriptionsState = {
    plans: [],
    selectedPriceId: null,
    loading: false,
    submitting: false,
    completed: false,
    error: null,
};

export const subscriptionsFeature = createFeature({
    name: "subscriptions",
    reducer: createReducer(
        initialState,
        on(SubscriptionsActions.pageOpened, (state) => ({
            ...state,
            loading: state.plans.length === 0,
            error: null,
        })),
        on(SubscriptionsActions.plansLoaded, (state, { plans }) => ({
            ...state,
            plans,
            loading: false,
        })),
        on(SubscriptionsActions.plansLoadFailed, (state, { message }) => ({
            ...state,
            loading: false,
            error: message,
        })),
        on(SubscriptionsActions.planSelected, (state, { priceId }) => ({
            ...state,
            selectedPriceId: priceId,
            completed: false,
            error: null,
        })),
        on(SubscriptionsActions.checkoutCancelled, (state) => ({
            ...state,
            selectedPriceId: null,
            error: null,
        })),
        on(SubscriptionsActions.invoiceCheckoutSubmitted, (state) => ({
            ...state,
            submitting: true,
            error: null,
        })),
        on(SubscriptionsActions.checkoutSucceeded, (state) => ({
            ...state,
            submitting: false,
            completed: true,
        })),
        on(SubscriptionsActions.checkoutFailed, (state, { message }) => ({
            ...state,
            submitting: false,
            error: message,
        })),
        on(SubscriptionsActions.reset, () => initialState)
    ),
    extraSelectors: ({ selectPlans, selectSelectedPriceId }) => ({
        selectSelectedPlan: createSelector(
            selectPlans,
            selectSelectedPriceId,
            (plans, priceId) =>
                plans.find((plan) => plan.priceId === priceId) ?? null
        ),
    }),
});
